import styled from 'styled-components';
import {
  InfoFilled,
  CheckmarkCircleRegular,
  TriangleFilled,
} from '@fluentui/react-icons';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { FocusTrapCallout } from '@fluentui/react';
import {
  PrimaryButton,
  SecondaryButton,
} from 'src/styles/globalStyles/buttonStyles.styled';
import { AddCircleFilled, DismissCircleFilled } from '@fluentui/react-icons';

export const ButtonAddIcon = styled(AddCircleFilled)`
  color: white;
  display: block;
  margin: auto;
  font-size: 40px;
  position: absolute;
`;

export const ButtonDismissIcon = styled(DismissCircleFilled)`
  color: white;
  display: block;
  margin: auto;
  font-size: 40px;
  position: absolute;
`;

export const PopupButton = styled(DefaultButton)`
  min-width: 5px !important;
  background-color: transparent;
  border: none;

  &:hover {
    background-color: transparent;
  }
`;

export const PopupCallout = styled(FocusTrapCallout)`
  width: 370px;
  min-height: 250px;
  padding: 15px 24px;

  .ms-Callout-beakCurtain,
  .ms-Callout-beak {
    background: ${(props) => props.theme.timesheetsPopupBackground};
  }
`;

export const PopupInput = styled.input`
  box-sizing: border-box;
  width: 80px;
  height: 32px;
  background-color: ${(props) => props.theme.timesheetsPopupInputBackground};
  color: ${(props) => props.theme.timesheetsTableTextMainColor};
  border-radius: 3px;
  padding: 10px;
  outline: none;
  font-size: 16px;

  input::placeholder {
    color: ${(props) => props.theme.timesheetsPopupInputColor};
  }

  border: none;

  &:focus,
  &:focus-within,
  &:active {
    border: none;
    border-bottom: 2px solid
      ${(props) => props.theme.timesheetsInputBorderColor};
  }

  &:disabled {
    border: none;
  }
`;

export const PopupHeading = styled.h3`
  font-weight: 700;
  color: ${(props) => props.theme.timesheetsTableTextMainColor};
  margin-bottom: 10px;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 37%;
  position: relative;
`;

export const DiscardButton = styled(SecondaryButton)`
  border-radius: 5px;
  height: 32px;
  width: 96px;
`;

export const SaveButton = styled(PrimaryButton)`
  border-radius: 5px;
  height: 32px;
  width: 96px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-around;
  gap: 5px;
`;

export const Containter = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 10px;
`;

export const PopupTextarea = styled.textarea`
  width: 100%;
  height: 120px;
  background-color: ${(props) => props.theme.timesheetsPopupInputBackground};
  color: ${(props) => props.theme.timesheetsTableTextMainColor};
  border: none;
  border-radius: 3px;
  padding: 10px;
  outline: none;
  resize: none;
  font-size: 16px;

  input::placeholder {
    color: ${(props) => props.theme.timesheetsPopupInputColor};
  }

  &:focus,
  &:focus-within,
  &:active {
    border-bottom: 2px solid
      ${(props) => props.theme.timesheetsInputBorderColor};
  }

  &:disabled {
    border: none;
  }
`;

export const PopupLabel = styled.label`
  color: ${(props) => props.theme.timesheetsTableTextMainColor};
`;

export const PopupForm = styled.div`
  background: ${(props) => props.theme.timesheetsPopupBackground};
`;

export const Alert = styled.div`
  width: 100%;
  min-height: 28px;
  max-height: 40px;
  background-color: ${(props) => props.theme.timesheetsAlertBackground};
  border: 1px solid ${(props) => props.theme.timesheetsAlertBorder};
  border-radius: 3px;
  display: none;
  align-items: center;
  gap: 5px;
  color: ${(props) => props.theme.timesheetInfoIconColor};
  padding: 0 10px;
  margin-top: 10px;
  position: relative;
`;

export const AlertIcon = styled(TriangleFilled)`
  color: ${(props) => props.theme.timesheetInfoIconColor};
  font-size: 20px;
`;

export const Exclamation = styled.div<{ exclamationPosition: boolean }>`
  position: absolute;
  font-size: 12px;
  top: 50%;
  transform: translate(0, -50%);
  color: ${(props) => props.theme.timesheetsAlertBackground};
  ${({ exclamationPosition }) => {
    if (exclamationPosition) {
      return 'left: 14.8px;';
    } else {
      return 'left: 18.7px;';
    }
  }}
`;

export const InfoIconHours = styled(InfoFilled)`
  color: ${(props) => props.theme.timesheetInfoIconColor};
  font-size: 18px;
  transform: rotate(180deg);
  position: absolute;
  bottom: 6px;
  right: 8px;
  font-size: 24px;
  display: none;
`;

export const CheckIconHours = styled(CheckmarkCircleRegular)`
  color: ${(props) => props.theme.timesheetsCheckIconColor};
  position: absolute;
  bottom: 6px;
  right: 8px;
  font-size: 24px;
  display: none;
`;
